var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "viq-source-card",
      class: { "viq-source-card--locked": _vm.source.locked },
      on: { click: _vm.handleClick },
    },
    [
      _c("div", { staticClass: "viq-source-card__number" }, [
        _vm._v(_vm._s(_vm.index)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "viq-source-card__content" }, [
        _vm.source.type
          ? _c("span", { staticClass: "viq-source-card__type" }, [
              _vm._v(_vm._s(_vm.source.type)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("h4", { staticClass: "viq-source-card__title" }, [
          _vm._v(_vm._s(_vm.source.title || "Untitled Source")),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "viq-source-card__meta" }, [
          _vm.source.jurisdiction
            ? _c("span", { staticClass: "viq-source-card__jurisdiction" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.source.jurisdiction) + "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.source.date
            ? _c("span", { staticClass: "viq-source-card__date" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.formatDate(_vm.source.date)) +
                    "\n      "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.source.locked
        ? _c("div", { staticClass: "viq-source-card__lock" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 14 14",
                  fill: "none",
                },
              },
              [
                _c("rect", {
                  attrs: {
                    x: "3",
                    y: "6",
                    width: "8",
                    height: "7",
                    rx: "1",
                    stroke: "currentColor",
                    "stroke-width": "1.2",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M5 6V4a2 2 0 014 0v2",
                    stroke: "currentColor",
                    "stroke-width": "1.2",
                    "stroke-linecap": "round",
                  },
                }),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }